const AUTH_SECTIONS_NAME = {
  START_LOGIN: 'start_login',
  START_SIGNUP: 'start_signup',
  LOGIN_FORM: 'login_form',
  SIGNUP_FORM: 'signup_form',
  GOOGLE_MODULE: 'google_module',
  LOGOUT_CONFIRM: 'logout_confirm',
  //Для одной секции
  FORGOT_PASS: 'forgot_pass',
  FORGOT_PASS_FROM_USER: 'forgot_pass_from_user',
  //xxxxxxxxxxxxxxxx
  FORGOT_PASS_SUCCESS: 'forgot_pass_success',
  RESET_PASS_FORM: 'reset_form',
};

export default AUTH_SECTIONS_NAME;
